import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, Star, AlertCircle } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 55,
    seconds: 32
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };else if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };else if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 text-2xl md:text-4xl font-bold font-poppins text-white" data-id="element-178">
      <div className="bg-navy-950 px-3 md:px-4 py-2 rounded-xl border border-navy-800 min-w-[64px] md:min-w-[80px] text-center" data-id="element-179">
        {pad(timeLeft.hours)}
        <span className="text-xs md:text-sm block text-slate-400 font-normal mt-1" data-id="element-180">
          hs
        </span>
      </div>
      <span className="text-purple-500 pb-6" data-id="element-181">:</span>
      <div className="bg-navy-950 px-3 md:px-4 py-2 rounded-xl border border-navy-800 min-w-[64px] md:min-w-[80px] text-center" data-id="element-182">
        {pad(timeLeft.minutes)}
        <span className="text-xs md:text-sm block text-slate-400 font-normal mt-1" data-id="element-183">
          min
        </span>
      </div>
      <span className="text-purple-500 pb-6" data-id="element-184">:</span>
      <div className="bg-navy-950 px-3 md:px-4 py-2 rounded-xl border border-navy-800 min-w-[64px] md:min-w-[80px] text-center" data-id="element-185">
        {pad(timeLeft.seconds)}
        <span className="text-xs md:text-sm block text-slate-400 font-normal mt-1" data-id="element-186">
          seg
        </span>
      </div>
    </div>;
}
export function PricingSection() {
  return <section id="pricing" className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative" data-id="element-187">
      <div className="max-w-5xl mx-auto" data-id="element-188">
        {/* Urgency Header */}
        <div className="text-center mb-12" data-id="element-189">
          <div className="inline-flex items-center gap-2 text-red-400 font-bold text-lg mb-6 bg-red-500/10 px-4 py-2 rounded-full border border-red-500/20" data-id="element-190">
            <Clock className="w-5 h-5 animate-pulse" data-id="element-191" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>

          <CountdownTimer data-id="element-192" />

          <div className="mt-6 flex items-center justify-center gap-2 text-yellow-400 font-medium" data-id="element-193">
            <AlertCircle className="w-5 h-5" data-id="element-194" />
            Después sube de precio. No vuelve.
          </div>

          <div className="mt-8 max-w-md mx-auto" data-id="element-195">
            <div className="flex justify-between text-sm text-slate-300 mb-2" data-id="element-196">
              <span data-id="element-197">Cupos al precio de lanzamiento</span>
              <span className="font-bold text-red-400" data-id="element-198">Quedan pocos</span>
            </div>
            <div className="h-3 bg-navy-950 rounded-full overflow-hidden border border-navy-800" data-id="element-199">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} className="h-full bg-gradient-to-r from-red-500 to-red-400 rounded-full relative" data-id="element-200">
                <div className="absolute inset-0 bg-white/20 animate-[pulse_2s_ease-in-out_infinite]" data-id="element-201" />
              </motion.div>
            </div>
            <p className="text-xs text-slate-400 mt-2 text-right" data-id="element-202">
              68% de los cupos ya tomados
            </p>
          </div>
        </div>

        <h2 className="text-3xl font-bold text-center mb-10" data-id="element-203">
          🛒 ELEGÍ TU PLAN Y EMPEZÁ HOY
        </h2>

        <div className="grid md:grid-cols-2 gap-8 items-stretch" data-id="element-204">
          {/* Standard Pack */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-navy-950 border border-navy-800 rounded-3xl p-6 md:p-8 flex flex-col relative hover:border-blue-500/50 transition-colors" data-id="element-205">
            <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-206">
              📘 PACK BÁSICO
            </h3>
            <p className="text-blue-400 font-medium mb-6" data-id="element-207">
              4 libros + 400 citas + bonos
            </p>

            <div className="bg-navy-900 rounded-xl p-4 mb-8 text-sm text-slate-300" data-id="element-208">
              <span className="font-semibold text-white" data-id="element-209">Ideal para:</span>{' '}
              Familias que quieren empezar a crear momentos especiales con sus
              hijos desde hoy
            </div>

            <div className="mt-auto" data-id="element-210">
              <div className="flex items-end gap-3 mb-6" data-id="element-211">
                <span className="text-2xl text-slate-500 line-through font-medium" data-id="element-212">
                  $65
                </span>
                <span className="text-4xl md:text-5xl font-bold text-white" data-id="element-213">
                  $12.90
                </span>
              </div>

              <button onClick={() => window.open('https://recursopack.com/cart/40898068152369:1', '_blank')} className="w-full bg-navy-800 hover:bg-navy-700 border border-blue-500/30 text-white font-bold py-4 px-6 rounded-xl transition-colors flex justify-center items-center gap-2 cursor-pointer" data-id="element-214">
                → QUIERO MI PACK BÁSICO
              </button>
            </div>
          </motion.div>

          {/* Master Pack (Recommended) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-gradient-to-b from-navy-800 to-navy-950 border-2 border-gold-500 rounded-3xl p-6 md:p-8 flex flex-col relative transform md:-translate-y-4 shadow-[0_0_40px_rgba(234,179,8,0.15)]" data-id="element-215">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gold-500 text-navy-900 font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1 shadow-lg" data-id="element-216">
              <Star className="w-4 h-4 fill-navy-900" data-id="element-217" /> MÁS ELEGIDO
            </div>

            <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-218">
              🏆 PACK COMPLETO
            </h3>
            <p className="text-gold-400 font-medium mb-6" data-id="element-219">
              6 libros + 600 citas + bonos
            </p>

            <div className="bg-navy-950/50 border border-gold-500/20 rounded-xl p-4 mb-8 text-sm text-slate-300" data-id="element-220">
              <span className="font-semibold text-white" data-id="element-221">Ideal para:</span>{' '}
              Familias que quieren la experiencia completa: Mamá e Hija, Mamá e
              Hijo, Papá e Hija, Papá e Hijo, Pareja y Familia
            </div>

            <div className="mt-auto" data-id="element-222">
              <div className="flex items-end gap-3 mb-6" data-id="element-223">
                <span className="text-2xl text-slate-500 line-through font-medium" data-id="element-224">
                  $95
                </span>
                <span className="text-4xl md:text-5xl font-bold text-white" data-id="element-225">
                  $18.90
                </span>
              </div>

              <button onClick={() => window.open('https://recursopack.com/cart/40916383236145:1', '_blank')} className="w-full bg-gradient-to-r from-gold-500 to-yellow-400 hover:from-gold-400 hover:to-yellow-300 text-navy-900 font-bold py-4 px-6 rounded-xl transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(234,179,8,0.4)] flex justify-center items-center gap-2 cursor-pointer" data-id="element-226">
                → QUIERO EL PACK COMPLETO
              </button>
            </div>
          </motion.div>
        </div>

        <p className="text-center mt-8 text-xs md:text-sm text-purple-400/70 font-medium" data-id="element-227">
          🌎 Pagalo en tu moneda local — Tarjeta de crédito, débito y más
        </p>
      </div>
    </section>;
}